import React, { useLayoutEffect } from 'react';
import './sonhos-celebres.component.scss';
import { Box, Button, SwipeableDrawer } from '@mui/material';
import SonhosCelebresModel from '../../models/sonhos-celebres.model';
import { GetSonhosCelebresService } from '../../services/pages.service';
import { SnackService } from '../../services/snack.service';
import { useHistory } from 'react-router-dom';
import ComentaiosComponent from '../comentarios/comentarios.component';

function SonhosCelebresComponent() {

  const [listSonhos, setListSonhos] = React.useState<Array<SonhosCelebresModel>>([]);
  const [sonhoDrawer, setSonhoDrawer] = React.useState<SonhosCelebresModel>();
  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);
  let history = useHistory();

  useLayoutEffect(() => {
    setTimeout(() => {
      GetEventos();
    }, 500);
  }, []);

  const GetEventos = () => {
    GetSonhosCelebresService({ user_id: '9', idsSonhos: [] }).then(res => {
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        setListSonhos(listSonhos.concat(res.data.sonhosArr));
      }
    }).catch(err => {
      //SnackService.sendMSG('Erro com a conexão ao consultar sonhos na base de dados.');
      console.log(err);
    });
  }

  const GoPage = (page: string) => {
    history?.push({
      pathname: `/${page}`
    })
  }

  return (
    <>
      <div className="box-sonhos">
        <div className="titulo flex flex-sp flex-cv">
          <h3>Sonhos célebres</h3>
          <Button className='link' onClick={() => GoPage('sonhos-celebres')}>Ver todos</Button>
        </div>
        <div className="cards-sonhos flex flex-ch">
          {
            listSonhos ? listSonhos.map((item, indexCurso) => (
              <div onClick={() => {
                setSonhoDrawer(item);
                setOpenDrawer(true);
              }} className="card-sonhos flex" key={indexCurso}>
                <div className="img" style={{ backgroundImage: 'url(' + item.imagem + ')' }}></div>
                <div className="txt">
                  <h2>{item.titulo}</h2>
                  <h3>{item.breve_descricao}</h3>
                </div>
              </div>
            )) : <span>Nenhum item encontrado.</span>
          }
        </div>
      </div>
      <SwipeableDrawer
        anchor='bottom'
        open={openDrawer}
        onClose={() => { setOpenDrawer(false) }}
        onOpen={() => { setOpenDrawer(true) }}
        className='sonhos-drawer'
      >
        <Box
          sx={{ height: '90vh', width: '100%' }}
          role="presentation"
        // onClick={() => { setOpenDrawer(false) }}
        //onKeyDown={() => { setOpenDrawer(false) }}
        >
          {
            sonhoDrawer &&
            <>
              <img src={sonhoDrawer?.imagem} alt={sonhoDrawer?.titulo} />
              <h2>{sonhoDrawer?.titulo}</h2>
              <div className="desc">
                {sonhoDrawer?.descricao}
              </div>
              <div className="box-comentarios">
                <ComentaiosComponent idPost={sonhoDrawer.id} palavrasModeradasADM={['bobo', 'bobão']} />
              </div>
            </>
          }
        </Box>
      </SwipeableDrawer>
    </>
  );
}

export default SonhosCelebresComponent;
